import React from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  FormControlLabel,
  Typography
} from '@material-ui/core';
import { initFalse } from '../../utils/constants';
import { sleep } from '../../utils/commonUtils';

export default function Disclaimer(props: any) {
  const {openDialog, setOpenDialog, setUnderstandDisclaimer} = props;
  const [disable, setDisable] = React.useState(!initFalse);

  const dp: DialogProps = {
    'aria-describedby':"alert-dialog-description",
    'aria-labelledby':"alert-dialog-title",
    disableEscapeKeyDown: !initFalse,
    maxWidth: "lg",
    open: openDialog,
  };
  const handleDisclaim = async () => {
    setUnderstandDisclaimer(!initFalse);
    sleep().then(() => setOpenDialog(initFalse));
  };

  return (
    <Dialog {...dp}>
      <Typography className="mt20 mb20 ml15">DISCLAIMER</Typography>
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-description">
          <Typography variant="subtitle1" className="textLight">
            This proposal is hypothetical and may not be used to project or predict insurance performance results in the
            future. Because these are projections, future policy performance and interest rates are not guaranteed and
            are subject to change by the insurer and/or lender. Underperformance could result in a lower death benefit,
            cash surrender value and lower annual income (results maybe less favorable). These are hypothetical examples
            - projections used for underwriting offer and illustrative purposes only. The estimated value is not an
            offer of coverage. The Benefits and values shown on the estimator are not guaranteed. This presentation is
            not valid unless accompanied by a complete insurance company illustration. Please see the full illustration
            for guaranteed values and other important information. nor any of its affiliates represent the lenders or
            the insurance carriers. This document is not intended to give legal advice or tax advice. For tax and legal
            advice contact your personal tax and legal agents.
          </Typography>
          <Typography variant="subtitle1" className="textLight">
            Illustrated projected bank loan payoff and income stream from policy loan and withdrawals will vary based on
            actual performance. Living Benefits are provided by the insurance carriers and all may not be available with
            all carriers or in all states. If you accelerate the benefit to access the living benefits, the amount
            accelerated is no longer available for the death benefit or for loans, and the amount of death benefit
            accelerated may be taxable. The loan must be paid off before you can accelerate the death benefit.
            Accelerated benefit riders are typically available at no additional cost. Please contact your insurance
            agent for more information.
          </Typography>
          <Typography variant="subtitle1" className="textLight">
            The Kai-Zen ® Plan is dependent on the client making contributions for the first 5 years therefore not defaulting on the
            plan. The Client contribution portion of the strategy includes a trustee and administration fee of $1350 per
            year. The fee covers only 15 years of trust fees. The fees pay for the initial trust setup, including the
            master trust, ongoing trustee administration of the insurance trust and annual loan servicing fees. Any
            changes to the trust outside the scope of the standard transactions are the responsibility of the settlor of
            the trust. The trust fees are non-refundable once the trust has been set up.
          </Typography>
          <Typography variant="subtitle1" className="textLight">
            Financing life insurance premiums has certain inherent risks including interest rate fluctuations, financial
            market performance, credit availability, insurance company ratings and stability which can affect the loan.
            Defaulting on the plan will result in bank loan exit and/or policy surrender. The loan terms are dependent
            on the lender and are not guaranteed for the full term of the plan.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <FormControlLabel
          className="formControlCheckbox"
          control={<Checkbox color="primary" onChange={() => setDisable(!disable)}/>}
          label="I Understand"
        />
        <Button
          className="btnPrimary"
          color="primary"
          disabled={disable}
          onClick={handleDisclaim}
          type="submit"
          variant="contained"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
